module.exports = "/_next/static/images/0a8badc09c77592a8cbf2245cad1ee1b-woman-holding-card-smiling@1x.jpg.webp";